.prices-container {
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 56px;
}

.prices {
  width: 100%;
  max-width: 640px !important;
}

.prices-block {
  margin-top: 18px;
  width: 90vw;
  max-width: 1080px !important;
  height: auto;
}

.price-card {
  width: calc(40% - 16px);
  padding: 32px;
  min-width: 180px;
}
.price-row {
  gap: 16px;
}